import { Loan } from '../schema';
import { GOODSAM_SOURCE_ID } from '../constants';
import { betterParseInt } from './betterParseInt';

// TRIDENT-896: emits utm_* (GoodSam path, legacy) alongside internal_*.
// CLEANUP-AFTER-SOAK: drop the utm-related imports, loanObj block, destructure,
// goodSamQueryParams array, and the GoodSam if-block below.
export function generateUrlParams(loan: Loan | null): string {
  const params = new URLSearchParams(window.location.search);
  const internalFromLoan = loan?.internal ?? {};
  const loanObj = loan || {
    id: params.get('loanId'),
    currentStep: params.get('currentStep'),
    source: params.get('source'),
    subSource: params.get('subsource'),
    keycode: params.get('keycode'),
    promocode: params.get('promocode'),
    member: params.get('member'),
    rateQuoteId: params.get('rqid'),
    salesForceId: params.get('sfid'),
    utm: {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_term: params.get('utm_term'),
      utm_content: params.get('utm_content'),
      utm_campaign: params.get('utm_campaign'),
    },
    facebookClickId: params.get('fbclid'),
    googleClickId: params.get('gclid'),
    purpose: params.get('purpose'),
    loanType: params.get('type'),
    repCode: params.get('repid'),
  };

  const {
    id: loanId,
    currentStep,
    source,
    subSource: subsource,
    keycode,
    promocode,
    member,
    rateQuoteId,
    salesForceId,
    utm,
    facebookClickId,
    googleClickId,
    purpose,
    loanType,
    repCode: repid,
  } = loanObj;

  const internalSource = internalFromLoan.internalSource ?? params.get('internal_source');
  const internalMedium = internalFromLoan.internalMedium ?? params.get('internal_medium');
  const internalCampaign = internalFromLoan.internalCampaign ?? params.get('internal_campaign');
  const internalContent = internalFromLoan.internalContent ?? params.get('internal_content');
  const internalTerm = internalFromLoan.internalTerm ?? params.get('internal_term');
  const internalId = internalFromLoan.internalId ?? params.get('internal_id');
  const internalName = internalFromLoan.internalName ?? params.get('internal_name');
  const internalPosition = internalFromLoan.internalPosition ?? params.get('internal_position');

  const queryParams = [
    [loanId, 'loanId'],
    [currentStep, 'currentStep'],
    [source, 'source'],
    [subsource, 'subsource'],
    [keycode, 'keycode'],
    [promocode, 'promocode'],
    [internalSource, 'internal_source'],
    [internalMedium, 'internal_medium'],
    [internalCampaign, 'internal_campaign'],
    [internalContent, 'internal_content'],
    [internalTerm, 'internal_term'],
    [internalId, 'internal_id'],
    [internalName, 'internal_name'],
    [internalPosition, 'internal_position'],
    [member, 'member'],
    [rateQuoteId, 'rqid'],
    [salesForceId, 'sfid'],
    [facebookClickId, 'fbclid'],
    [googleClickId, 'gclid'],
    [purpose, 'purpose'],
    [loanType, 'type'],
    [repid, 'repid'],
  ];

  // TRIDENT-896: GoodSam-only utm_* emission. CLEANUP-AFTER-SOAK: delete.
  const goodSamQueryParams = [
    [utm?.utm_source, 'utm_source'],
    [utm?.utm_medium, 'utm_medium'],
    [utm?.utm_term, 'utm_term'],
    [utm?.utm_content, 'utm_content'],
    [utm?.utm_campaign, 'utm_campaign'],
  ];

  let urlParams: string = '';

  queryParams.forEach((item) => {
    if (item[0] !== null && item[0] !== undefined && item[0] !== '') {
      urlParams += `${item[1]}=${encodeURIComponent(String(item[0]))}&`;
    }
  });

  // TRIDENT-896: CLEANUP-AFTER-SOAK: delete this block.
  if (betterParseInt(source) === GOODSAM_SOURCE_ID) {
    goodSamQueryParams.forEach((item) => {
      if (item[0] !== null && item[0] !== undefined && item[0] !== '') {
        urlParams += `${item[1]}=${encodeURIComponent(String(item[0]))}&`;
      }
    });
  }

  return urlParams === '' ? urlParams : `?${urlParams.replace(/&$/, '')}`;
}
